<template>
  <v-container>
    <v-row justify="center">
      <v-btn
        v-for="type in bettypeslist"
        :key="type"
        :class="{ 'v-btn--active': currentbettype === type }"
        @click="betTypeClick(type)"
      >
        {{ type }}
      </v-btn>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { NO_LIMIT } from '@/constants/constants';
import { useBetTypesStore } from '@/stores/betTypes';

const props = defineProps({
  bettype: {
    type: String,
    required: false,
    default: NO_LIMIT
  }
});

const emit = defineEmits(['bettypeclick']);

const betTypesStore = useBetTypesStore();
const bettypeslist = computed(() => betTypesStore.bettypeslist);

const currentbettype = ref(NO_LIMIT);

const betTypeClick = (type) => {
  currentbettype.value = type;
  emit('bettypeclick', { localvar: type });
};

onMounted(() => {
  currentbettype.value = props.bettype;
  if (!betTypesStore.bettypeslist.length) {
    betTypesStore.createBetTypesList();
  }
});
</script>

<style>
/* Add any custom styles here */
</style>
